import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import {
  fetchUserData,
  GetUserTasks,
  fetchUserEditData,
  UserTaskList,
} from "../Services/APIService";
import { useNavigate } from "react-router-dom";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";
import { useLocation } from "react-router-dom";
import CreateUserTaskDemo from "../Components/CreateUserTaskDemo";
import EditUserTaskDemo from "../Components/EditUserTaskDemo";
import { Toaster, toast } from "react-hot-toast";
import { get } from "http";
import { CreateUserTaskRequest } from "../Components/CreateUserTaskDemo";
import UpdatedUserTaskComponent from "../Components/UpdatedUserTaskComponent";
import OverlayLoader from "../Components/OverlayLoader";

// User Interface
interface User {
  tenantId: number;
  userId: number;
  userName: string;
  mobile: string;
  email: string;
  alternativePhone: string;
  reportTo: number;
  groupId: number;
  isFallbackUser: boolean;
  isActive: boolean;
  userStatusId: number;
  userTypeId: number;
  reportToUserName: string;
  groupName: string;
}

interface MenuItem {
  menuID: number;
  menuName: string;
  menuUrl: string;
  icon: string;
  subMenuList?: [];
}

interface ContactFormData {
  email: string;
  firstName: string;
  lastName: string;
  contactOwner: string;
  jobTitle: string;
  phoneNumber: string;
}

interface UpdateStatusData {
  tenantId: number;
  leadId?: number;
  assignedUser?: number;
  isCompleted?: boolean;
  followupDate?: string; // or Date if you're using Date objects
}

const UserTaskTable: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [allowedMenus, setAllowedMenus] = useState<MenuItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [usersTask, setusersTask] = useState<UserTaskList[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [searchText, setSearchText] = useState<string>("");
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState<UserTaskList[]>([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [editUserData, setEditUserData] = useState<any>(null); // Store the edit user data
  const [selectedLeadId, setSelectedLeadId] = useState<number | null>(null);
  const leadId = location.state?.LeadId || null;
  const openAddModal = location.state?.openAddModal || false;
  const [isUpdateStatusModalOpen, setIsUpdateStatusModalOpen] = useState(false);
  const [updateStatusData, setUpdateStatusData] =
    useState<UpdateStatusData | null>(null);
  // console.log('leadId0',leadId);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  useEffect(() => {
    if (openAddModal) {
      setIsModalOpen(true);
    }
  }, [openAddModal]);

  useEffect(() => {
    const getMenus = async () => {
      setIsLoading(true);
      try {
        const menuID = location.state?.menuID;
        const subMenuId = location.state?.subMenuId;
        const userDataUpdated = location.state?.userDataUpdated; // Add this

        const previousMenuID = localStorage.getItem("activeMenuID");
        if (menuID !== previousMenuID || menuID === null) {
          localStorage.setItem("activeMenuID", menuID);
        } else {
          localStorage.removeItem("activeMenuID");
        }

        // Handle user data update
        if (userDataUpdated) {
          toast.success("User Task Create Successfully");
          fetchUsersTask();
          const { userDataUpdated: _, ...newState } = location.state;
          navigate(location.pathname, {
            state: newState,
            replace: true,
          });
        }

        if (subMenuId == 3) {
          setIsModalOpen(true);
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getMenus();
  }, [location.state]);

  useEffect(() => {
    fetchUsersTask();
  }, []);

  const fetchUsersTask = async (): Promise<void> => {
    try {
      const usersTaskData = await GetUserTasks();
      const filteredUsersTask = usersTaskData.filter(
        (userTask) =>
          userTask.followupTypeId != 1 &&
          userTask.isCanceled == false &&
          userTask.isCompleted == false &&
          userTask.isPostponed == false
      );
      setusersTask(filteredUsersTask);
      setLoading(false);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "An unknown error occurred"
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    const editTaskId = location.state?.editTaskId;
    const actionType = location.state?.actionType;

    if (editTaskId) {
      handleEdit(editTaskId, actionType);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.openAddModal && location.state?.LeadId) {
      setIsModalOpen(true);
      setSelectedLeadId(location.state.LeadId); // New state to track selected lead
    }
  }, [location.state]);

  const handleEdit = async (taskId: number, actionType?: string) => {
    try {
      const response = await GetUserTasks();
      const matchedTask = response.find((task) => task.id === taskId);
      console.log("actionType", actionType);
      if (matchedTask) {
        setEditUserData({ ...matchedTask, actionType }); // add actionType if needed in modal
        setIsEditModalOpen(true);
      } else {
        throw new Error("No user data found");
      }
    } catch (error) {
      console.error("Error fetching user edit data:", error);
      alert("Failed to fetch user data for editing");
    }
  };

  const handleRowSelected = (state: { selectedRows: UserTaskList[] }) => {
    setSelectedRows(state.selectedRows);
  };

  const handleCreateContact = (contactData: CreateUserTaskRequest) => {
    console.log("Creating contact:", contactData);
    alert(
      `Contact created: ${contactData.assignedUser} ${contactData.projectName}`
    );
  };

  const handleEditSubmit = (updatedData: any) => {
    setIsEditModalOpen(false);
    setEditUserData(null);
  };

  const handleUpdateStatus = async (taskId: number) => {
    try {
      const response = await GetUserTasks();
      const matchedTask = response.find((task) => task.id === taskId);

      if (matchedTask) {
        // Get tenantId from localStorage
        const tenantId =
          localStorage.getItem("tenantId") || localStorage.getItem("tenant_id");

        if (!tenantId) {
          alert("Tenant ID not found in localStorage");
          return;
        }

        setUpdateStatusData({
          tenantId: parseInt(tenantId),
          leadId: matchedTask.leadId, // or matchedTask.leadId if that's the field name
          assignedUser: matchedTask.assignedUser,
          isCompleted: matchedTask.isCompleted || false,
          followupDate: matchedTask.followupDate,
        });
        setIsUpdateStatusModalOpen(true);
      } else {
        throw new Error("No task data found");
      }
    } catch (error) {
      console.error("Error fetching task data for status update:", error);
      alert("Failed to fetch task data for status update");
    }
  };

  // Filter users based on search input
  const filteredUsers = usersTask.filter(
    (userstask) =>
      // userstask.projectName.toLowerCase().includes(searchText.toLowerCase()) ||
      userstask.followupTypeName
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      userstask.assignedUserName
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      userstask.leadName.toLowerCase().includes(searchText.toLowerCase())
  );

  // Columns including SL No
  const columns = [
    {
      name: "Lead Name",
      selector: (row: UserTaskList) => row.leadName,
      sortable: true,
      cell: (row: UserTaskList) => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: "rgb(167 133 144)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "10px",
              fontWeight: "bold",
            }}
          >
            {row.leadName.charAt(0).toUpperCase()}
          </div>
          <span style={{ fontWeight: "500", color: "#33475b" }}>
            {row.leadName}
          </span>
        </div>
      ),
      width: "200px",
    },
    {
      name: "Follow-up Type Name",
      selector: (row: UserTaskList) => row.followupTypeName,
      sortable: true,
    },
    {
      name: "Assigned User Name",
      selector: (row: UserTaskList) => row.assignedUserName,
      sortable: true,
    },
    {
      name: "Project Name",
      selector: (row: UserTaskList) => row.projectName,
      sortable: true,
    },
    {
      name: "Follow-up Date",
      selector: (row: UserTaskList) => {
        if (!row.followupDate) return "";

        const date = new Date(row.followupDate);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");

        return `${day}-${month}-${year} ${hours}:${minutes}`;
      },
    },
    {
      name: "Status",
      selector: (row: UserTaskList) => row.isCompleted,
      sortable: true,
      cell: (row: UserTaskList) => {
        const isCompleted =
          typeof row.isCompleted === "boolean"
            ? row.isCompleted
            : row.isCompleted === "true";

        const isCanceled =
          typeof row.isCanceled === "boolean"
            ? row.isCanceled
            : row.isCanceled === "true";

        const isPostponed =
          typeof row.isPostponed === "boolean"
            ? row.isPostponed
            : row.isPostponed === "true";

        let statusText = "Need Status Update";

        if (isCompleted) {
          statusText = "Completed";
        } else if (isCanceled) {
          statusText = "Canceled";
        } else if (isPostponed) {
          statusText = "Postponed";
        }
        const isActive = isCompleted || isCanceled || isPostponed;
        return (
          <span className={isActive ? "active-status" : "inactive-status"}>
            {statusText}
          </span>
        );
      },
      width: "170px",
    },
    {
      name: "",
      cell: (row: UserTaskList) => (
        <div className="action-cell">
          <button
            className="action-button edit-button"
            title="Edit User Task"
            onClick={() => handleEdit(row.id)}
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button
            className="action-button edit-button"
            title="Update Status"
            onClick={() => handleUpdateStatus(row.id)}
          >
            <i className="bi bi-arrow-repeat"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "60px",
    },
  ];

  if (error) {
    return <div className="p-4 text-red-500">Error: {error}</div>;
  }

  return (
    <div className="wrapper">
      <div>
        <Toaster
          position="top-center"
          reverseOrder={false}
          containerStyle={{
            zIndex: 10000,
          }}
        />
      </div>
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />
        <div className="main-content-div">
          <div className="main-header-div"></div>
          <main className="content mainContent">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-12 col-lg-12">
                  <div className="card">
                    <div className="card-header carHeaderWithBtn">
                      <div className="card-title mb-0">
                        Active Follow-up List
                      </div>
                      <div>
                        {" "}
                        <input
                          type="text"
                          placeholder="Search by Assigner, Lead Name or Follow-up Type"
                          className="p-2 w-full datatableSearchInput"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          style={{ width: "21rem" }}
                        />
                      </div>
                    </div>
                    <div className="card-body p-0">
                      <DataTable
                        columns={columns}
                        data={filteredUsers}
                        pagination
                        paginationPerPage={10}
                        highlightOnHover
                        striped
                        responsive
                        //noDataComponent="No users found"
                        selectableRows
                        selectableRowsComponentProps={{
                          className: "custom-checkbox",
                        }}
                        onSelectedRowsChange={handleRowSelected}
                        clearSelectedRows={toggleCleared}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CreateUserTaskDemo
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onSubmit={handleCreateContact}
              preselectedLeadId={leadId} // <-- Add this line, or any dynamic leadId
            />
            <EditUserTaskDemo
              isOpen={isEditModalOpen}
              onClose={() => {
                setIsEditModalOpen(false);
              }}
              onSubmit={handleEditSubmit}
              //selectedRows={selectedRows}
              taskData={editUserData}
              onTaskUpdated={fetchUsersTask}
            />
            {isUpdateStatusModalOpen && updateStatusData && (
              <UpdatedUserTaskComponent
                tenantId={updateStatusData.tenantId}
                leadId={updateStatusData.leadId}
                assignedUser={updateStatusData.assignedUser}
                isCompleted={updateStatusData.isCompleted}
                followupDate={updateStatusData.followupDate}
                isOpen={isUpdateStatusModalOpen} // Add this prop
                onClose={() => {
                  setIsUpdateStatusModalOpen(false);
                  setUpdateStatusData(null); // Clear the data when closing
                }}
                onTaskUpdated={fetchUsersTask}
              />
            )}
          </main>
        </div>
        <Footer />
      </div>
      <OverlayLoader
        loading={loading}
        message="Loading User Task Data"
        submessage="This might take a moment..."
      />
    </div>
  );
};

export default UserTaskTable;
